import classNames from 'classnames';
import { type ReactNode, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const PriceArea = styled.div`
  min-height: 128px;
`;

const TopPriceZone = styled.div.attrs({ className: 'd-flex justify-content-between align-items-center p-2' })`
  height: 48px;
`;

type SidePanelColor = 'success' | 'info' | 'warning' | 'danger' | 'primary' | 'secondary';

interface SimpleSidePanelStatusProps {
  color: SidePanelColor;
  children?: ReactNode;
}

export function ErrorSidePanelStatus({ color, children }: SimpleSidePanelStatusProps) {
  return (
    <div id="side-panel-status" className="d-grid">
      <PriceArea className={classNames('d-flex flex-column alert p-3', `alert-discreet-${color}`)}>
        {children}
      </PriceArea>
    </div>
  );
}

interface PriceSidePanelStatusProps extends SimpleSidePanelStatusProps {
  topLeft: ReactNode;
  topRightActions?: ReactNode;
}

export function PriceSidePanelStatus({ color, children, topLeft, topRightActions }: PriceSidePanelStatusProps) {
  return (
    <div className="d-grid">
      <PriceArea className={classNames('d-flex flex-column alert p-0', `alert-discreet-${color}`)}>
        <TopPriceZone>
          <h6 className="ps-2" data-e2e="solving-mode">
            {topLeft}
          </h6>
          <div>{topRightActions}</div>
        </TopPriceZone>
        <div className="d-flex flex-grow-1 align-items-end h-100">{children}</div>
      </PriceArea>
    </div>
  );
}

interface PublishButtonProps {
  color?: SidePanelColor;
  onPublish(): void;
}

export function PublishButton({ onPublish, color }: PublishButtonProps) {
  const { formatMessage } = useIntl();
  const [isClicked, setIsClicked] = useState(false);
  function onClicked() {
    setIsClicked(true);
    onPublish();
  }
  return (
    <button
      data-e2e="publish-button"
      type="button"
      className={classNames({ [`btn btn-flat-${color}`]: color })}
      onClick={onClicked}
      disabled={isClicked}
      title={formatMessage({ id: 'publish' })}
    >
      <em className="icon icon-sm">public</em>
    </button>
  );
}
